// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v4cJGHpdTQbsTSyeEANmDg\\=\\={color:transparent;position:absolute;overflow:hidden;width:100%;height:2px;z-index:-1}html[dir] .v4cJGHpdTQbsTSyeEANmDg\\=\\={padding:0;margin:0;border:0;background:transparent}", ""]);
// Exports
exports.locals = {
	"anchorButton": "v4cJGHpdTQbsTSyeEANmDg=="
};
module.exports = exports;
